import { skipToken, useQuery } from '@tanstack/react-query';
import { orpc } from '@/api/rpc/client';

export function useArStatementDefaults(customerId: string | undefined) {
  const query = useQuery({
    ...orpc.accountsReceivable.arStatementDefaults.get.queryOptions({
      input: customerId ? { customerId } : skipToken,
    }),
  });

  return {
    // Recipients only. Send-from defaults to the current user's mailbox and BCC
    // to AR module config `outboxBccEmails` — resolved in the dialog, not here.
    defaultRecipientEmails: query.data?.defaultRecipientEmails ?? [],
    isLoading: query.isLoading,
  };
}
